import type { ApiResponse } from '@abaninja/types';

import { httpClient } from '@abaninja/util-http-client';
import { createCancellablePromise } from '@abaninja/util-store';

import { type DeepBoxStatus } from '../@types';

export function getDeepbox(accountUuid: string) {
  return createCancellablePromise(
    ({ signal }) => httpClient.get<ApiResponse<DeepBoxStatus>>(`/accounts/${accountUuid}/deepcloud/v1/deepbox`, { signal }),
  );
}

export function createDeepbox(accountUuid: string) {
  return httpClient.post<ApiResponse<DeepBoxStatus>>(`/accounts/${accountUuid}/deepcloud/v1/deepbox`);
}
